module.exports = __webpack_public_path__ + "static/media/icon-lose.7c5b27ca.png";